import React from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Box, Button,
  Flex, Icon, Popover,
  PopoverArrow, PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger, useDisclosure
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../constants/analyticsIds';
import {
  resetToDefaultContentTemplate,
  resetToDefaultSignatureTemplate
} from '../../../../redux/modules/emails';
import { showModal } from '../../../../redux/modules/modal';

import CompanyEmailTemplates from './CompanyEmailTemplates';
import DepartmentEmailTemplates from './DepartmentEmailTemplates';
import SaveEmailTemplateForm from './SaveEmailTemplateForm';

const EmailTemplateDropdown = ({ type, templateWord, disableTemplateCreation, defaultTemplates }) => {
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const { isOpen, onToggle, onClose } = useDisclosure();

  const resetToDefaultTemplateHandler = templateType => {
    if (templateType === 'main_content') {
      dispatch(resetToDefaultContentTemplate());
    } else {
      dispatch(resetToDefaultSignatureTemplate());
    }

    onClose();
  };

  const handleSaveTemplate = () => {
    dispatch(showModal(() => (
      <SaveEmailTemplateForm companyId={companyId} templateWord={templateWord} type={type} />
    ), {
      actionRequired: true,
      buttons: {},
      center: true,
      size: 'sm',
      title: 'Save Template'
    }));
  };

  return (
    <Popover
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
    >
      <PopoverTrigger>
        <Button
          data-analytics-id={analyticsIds.emailEditorPage.templateSelectorPopoverButton}
          rightIcon={<Icon as={BsChevronDown} />}
          variant="secondary"
          onClick={onToggle}
        >
          Templates
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody maxW="800px">
          {!isOpen ? null : (
            <Box h="525px" w="100%">
              <Flex flexFlow="row nowrap" justifyContent="flex-start" my={4}>
                {!disableTemplateCreation && (
                  <Button
                    mx={2}
                    variant="primary"
                    onClick={handleSaveTemplate}
                  >
                    {`Save As New ${templateWord}`}
                  </Button>
                )}
                <Button
                  mx={2}
                  variant="accent"
                  onClick={() => resetToDefaultTemplateHandler(type)}
                >
                  {`Use Default ${templateWord}`}
                </Button>
              </Flex>

              <Flex flexFlow="row nowrap" justifyContent="space-around">
                <CompanyEmailTemplates
                  defaultTemplates={defaultTemplates}
                  templateWord={templateWord}
                  type={type}
                  width="350px"
                  onSelect={onClose}
                />
                <DepartmentEmailTemplates
                  templateWord={templateWord}
                  type={type}
                  width="350px"
                />
              </Flex>
            </Box>
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

EmailTemplateDropdown.propTypes = {
  type: PropTypes.oneOf(['main_content', 'signature']).isRequired,
  templateWord: PropTypes.string,
  disableTemplateCreation: PropTypes.bool,
  defaultTemplates: PropTypes.arrayOf(PropTypes.shape({}))
};

export default EmailTemplateDropdown;
